import React from 'react';
import Check from 'wix-ui-icons-common/Check';
import large from './group@3x.jpg';
import small from './group.jpg';
import medium from './group@2x.jpg';
import styles from './FirstTimeWelcome.scss';

import { Button, Heading, Text } from 'wix-style-react';

export const FirstTimeWelcome = props => {
  const { onStartClick } = props;
  return (
    <div className={styles.wrapper} data-hook="first-time-wrapper">
      <div className={styles.leftColumn}>
        <div>
          <Heading className={styles.heading} appearance="H1" data-hook="first-time-title">
            Welcome to Phone Ordering
          </Heading>
          <Text>Now you can take customer orders right over the phone. </Text>
          {renderChecklist()}
          <Button className={styles.button} onClick={onStartClick} dataHook="start-now-button">
            Start Now
          </Button>
        </div>
      </div>
      <div className={styles.rightColumn}>
        <img srcSet={`${small} 1x, ${medium} 2x, ${large} 3x`} alt={'welcome'} />
      </div>
    </div>
  );
};

const renderChecklist = () => {
  const checklistItems = [
    'Track and manage all your orders in one place',
    'Assign team members to handle incoming calls',
    'Offer faster checkout to returning customers',
  ];
  return (
    <div className={styles.checklist}>
      {checklistItems.map((item, index) => {
        return (
          <div className={styles.item} key={index}>
            <Check style={{ marginRight: '18px' }} />
            <Text>{item}</Text>
          </div>
        );
      })}
    </div>
  );
};
